export class NotificationType {
    id: number;
    name:string;
    description:string;
    color:string;

    constructor (id:number, name:string, description:string, color:string) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.color = color;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/notification-type.ts